import axios, { AxiosPromise } from 'axios'
import {
  EmitirBundleFhirDigitalInput,
  EmitirBundleFhirDigitalPopupInput,
} from 'hooks/assinatura-digital/model-assinaturaDigitalPopup'

export class BundleFhirDigital {
  gerarBundleFhirDigital(input: EmitirBundleFhirDigitalPopupInput): AxiosPromise {
    return axios.post('/api/bundleFhirDigital/gerarBundleFhirDigital', input, { responseType: 'text' })
  }

  emitirBundleFhirDigital(input: EmitirBundleFhirDigitalInput): AxiosPromise {
    return axios.post('/api/bundleFhirDigital/emitirBundleFhirDigital', input)
  }
}
